import React from 'react'
import PropTypes from 'prop-types'
import { Card, Text, Flex } from 'pcln-design-system'
import { ArrowRight } from 'pcln-icons'
import styled from 'styled-components'
import Cookies from 'cookies-js'
import FireRudderstackImpressionEvent from './FireRudderstackImpressionEvent'

const HeadingText = styled(Text)`
  text-transform: capitalize;
`
export function MobileHotelCrossSellComponent({
  bannerMx,
  handleItemClick,
  title,
  headingCopy,
  subheadingCopy,
  isDetails,
}) {
  const dataCguid = Cookies.get('SITESERVER')
  const rudderstack = {
    'data-rudder-event': true,
    'data-sub-type': 'cross_sell',
    'data-cguid': dataCguid?.slice(3),
    'data-child-product': 'STAY',
    'data-parent-product': 'FLY',
    'data-source': isDetails ? 'flights details' : 'flights listing',
    'data-category': 'click',
  }

  return (
    <Card
      id={'package-cross-sell'}
      boxShadowSize='md'
      borderWidth={0}
      borderRadius='16px'
      bg='background.lightest'
      color='background.light'
      mx={bannerMx}
      mb={bannerMx === 3 && 3}
      onClick={handleItemClick}
      //rudderstack attributes
      {...rudderstack}
    >
      <FireRudderstackImpressionEvent
        rudderstack={{ ...rudderstack, 'data-category': 'impression' }}
      >
        <Flex
          alignItems='center'
          flexDirection='row'
          justifyContent='space-between'
          px={3}
          py={2}
        >
          <Flex flexDirection='column'>
            <HeadingText color='text.light' mb={1} textStyle='caption'>
              {title}
            </HeadingText>
            <Text bold color='text.base' mb={1} textStyle='heading6'>
              {headingCopy}
            </Text>
            <Text bold color='text.base' textStyle='caption'>
              {subheadingCopy}
            </Text>
          </Flex>
          <ArrowRight color='primary.base' width={20} height={20} ml={2} />
        </Flex>
      </FireRudderstackImpressionEvent>
    </Card>
  )
}

MobileHotelCrossSellComponent.propTypes = {
  flyGaLogic: PropTypes.object.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  bannerMx: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  title: PropTypes.string,
  headingCopy: PropTypes.string,
  subheadingCopy: PropTypes.string,
  rudderstack: PropTypes.array,
  isDetails: PropTypes.bool,
}

MobileHotelCrossSellComponent.defaultProps = {
  bannerMx: 3,
  title: 'Bundle + Save',
  headingCopy: 'Save an average of $240 on your trip',
  subheadingCopy: 'Book a hotel + flight together for extra savings.',
}
